module.exports = __webpack_public_path__ + "media/images/vector-55@2x-f95312e28e90b78f37231c2d1d746767.png";